<div class="feature-card">
  <div class="icon-box"><img [src]="icon()" [alt]="title()"></div>
  <h3>{{ title() }}</h3>
  <p>{{ subtitle() }}</p>
</div>
